import { call, put, takeEvery } from "redux-saga/effects";

// Chat Redux States
import {
  GET_MT_AGENCIES_LIST, GET_MT_BANNERS_LIST, GET_MT_CAMPAIGNS_LIST,
  GET_TIKTOK_ADVERTISERS_LIST,
  GET_VK_BANNER_LIST,
  GET_VK_CAMPAIGNS_LIST,
  GET_VK_CLIENT_LIST
} from "./actionTypes";
import {
  hideBannersVkListLoader,
  hideCampaignsVkListLoader,
  hideClientsVkListLoader,
  hideMTAgenciesListLoader,
  hideMTBannersListLoader, hideMTCampaignsListLoader,
  hideTikTokAdvertisersListLoader,
  setBannersVkList,
  setCampaignsVkList,
  setClientsVkList,
  setMTAgenciesList,
  setMTBannersList, setMTCampaignsList,
  setTikTokAdvertisersList,
  showBannersVkListLoader,
  showCampaignsVkListLoader,
  showClientsVkListLoader,
  showMTAgenciesListLoader,
  showMTBannersListLoader,
  showMTCampaignsListLoader,
  showTikTokAdvertisersListLoader
} from "./actions";

import {
  getWarehouseIntegrationAdvertisersTikTokList,
  getWarehouseIntegrationAgenciesMTList,
  getWarehouseIntegrationBannersMTList,
  getWarehouseIntegrationBannersVkList, getWarehouseIntegrationCampaignsMTList,
  getWarehouseIntegrationCampaignsVkList,
  getWarehouseIntegrationClientsVkList
} from "../../helpers/jwt_helper";
import { getErrorMessage, showErrorMessage } from "../../helpers/utils";

let timestampToDate = timestamp => {
  let date = new Date(timestamp*1000);
  let day = date.getDate();
  let month = (date.getMonth()+1);
  let year = date.getFullYear();
  let hours = date.getHours();
  let minutes = "0" + date.getMinutes();
  let seconds = "0" + date.getSeconds();
  return day + '-' + month + '-' + year + ' ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2)
}

function* onGetCampaignsVkList({payload: data}) {
  try {
    yield put(showCampaignsVkListLoader());
    // console.log(data);
    let response = yield call(getWarehouseIntegrationCampaignsVkList, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search
    })
    response = {
      ...data,
      ...response,
      results: response.results.map(i => {
        return ({
          ...i,
          create_time: timestampToDate(i.create_time),
          update_time: timestampToDate(i.update_time),
        });
      })
    }
    yield put(setCampaignsVkList(response));
    yield put(hideCampaignsVkListLoader());
  } catch (error) {
    yield put(hideCampaignsVkListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetClientsVkList({ payload: data }) {
  try {
    yield put(showClientsVkListLoader());
    // console.log(data);
    let response = yield call(getWarehouseIntegrationClientsVkList, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
          ...i,
        }))
    };
    //console.log(response);
    yield put(setClientsVkList(response));
    yield put(hideClientsVkListLoader());
  } catch (error) {
    yield put(hideClientsVkListLoader());
  }
}

function* onGetBannersVkList({payload: data}) {
  try {
    yield put(showBannersVkListLoader());
    // console.log(data);
    let response = yield call(getWarehouseIntegrationBannersVkList, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search
    })
    response = {
      ...data,
      ...response,
      results: response.results.map(i => {
        return ({
          ...i,
          create_time: timestampToDate(i.create_time),
          update_time: timestampToDate(i.update_time),
        });
      })
    }
    yield put(setBannersVkList(response));
    yield put(hideBannersVkListLoader());
  } catch (error) {
    yield put(hideBannersVkListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetAdvertisersTikTokList({payload: data}) {
  try {
    yield put(showTikTokAdvertisersListLoader());
    // console.log(data);
    let response = yield call(getWarehouseIntegrationAdvertisersTikTokList, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search
    })
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
        ...i,
      }))
    };
    yield put(setTikTokAdvertisersList(response));
    yield put(hideTikTokAdvertisersListLoader());
  } catch (error) {
    yield put(hideTikTokAdvertisersListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetAgenciesMTList({payload: data}) {
  try {
    yield put(showMTAgenciesListLoader());
    // console.log(data);
    let response = yield call(getWarehouseIntegrationAgenciesMTList, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search
    })
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
        ...i,
      }))
    };
    yield put(setMTAgenciesList(response));
    yield put(hideMTAgenciesListLoader());
  } catch (error) {
    yield put(hideMTAgenciesListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetBannersMTList({payload: data}) {
  try {
    yield put(showMTBannersListLoader());
    // console.log(data);
    let response = yield call(getWarehouseIntegrationBannersMTList, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search
    })
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
        ...i,
      }))
    };
    yield put(setMTBannersList(response));
    yield put(hideMTBannersListLoader());
  } catch (error) {
    yield put(hideMTBannersListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetCampaignsMTList({payload: data}) {
  try {
    yield put(showMTCampaignsListLoader());
    // console.log(data);
    let response = yield call(getWarehouseIntegrationCampaignsMTList, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search
    })
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
        ...i,
      }))
    };
    yield put(setMTCampaignsList(response));
    yield put(hideMTCampaignsListLoader());
  } catch (error) {
    yield put(hideMTCampaignsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* integrationListSaga() {
  yield takeEvery(GET_VK_CAMPAIGNS_LIST, onGetCampaignsVkList);
  yield takeEvery(GET_VK_CLIENT_LIST, onGetClientsVkList);
  yield takeEvery(GET_VK_BANNER_LIST, onGetBannersVkList);
  yield takeEvery(GET_TIKTOK_ADVERTISERS_LIST, onGetAdvertisersTikTokList);
  yield takeEvery(GET_MT_AGENCIES_LIST, onGetAgenciesMTList);
  yield takeEvery(GET_MT_BANNERS_LIST, onGetBannersMTList);
  yield takeEvery(GET_MT_CAMPAIGNS_LIST, onGetCampaignsMTList);
}

export default integrationListSaga;
